import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-destructive text-xs"
}

import { UserCompany } from '@/types';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserCompanyName',
  props: {
    userCompany: {}
  },
  setup(__props: any) {

    

    const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.userCompany.name) + " ", 1),
    (_ctx.userCompany.deactivated_at)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(_unref(t)('companies.deactivated')) + ") ", 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})